export const ENDPOINTS = {
  EQUIPOS: {
    BASE: '/mp_equipos',
    TAREAS: '/tareas',
  },
  VENCIMIENTOS: {
    BASE: '/mp_vencimientos',
  },
  OTS: {
    BASE: '/mp_ots',
    PORPLANTA: '/porplanta',
    REALIZADAS: '/realizadas',
    HISTORIAL: '/historial',
  },
  CORRECTIVOS:{
    BASE: '/mp_correctivos',
    REALIZADAS: '/realizadas',
    HISTORIAL: '/historial',
  }
};
